/*
 * @Author: zhang lin
 * @Date: 2022-04-07 14:28:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-24 13:59:42
 * @Description: file content
 */
import React from 'react';
import styles from './index.less';
import { Button } from 'sup-ui';
import { useIntl } from 'react-intl';
import messages from 'root/pages/InstallSupos/messages';
import { useSelector, useDispatch } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { envManage } from 'root/pages/EnvManage/store/actions';

// import Modal from '../CommonModal';
// import { cancelTask } from 'root/services/manager';

interface PropsType {
  step: string;
  stepAdd: Function;
  cancelFn: Function;
  prevStep: Function;
  disabled?: boolean;
  suposUrl?: string;
}

// const { confirm } = Modal;

const Footer = (props: PropsType) => {
  const intl = useIntl();
  const { cluster } = useSelector((state: reducerStates) => state.envManage);
  const dispatch = useDispatch();
  const enableMultiInstance = sessionStorage.getItem('enableMultiInstance'); // 是否支持多实例

  // step:步骤标识   修改步骤索引stepAdd  cancelFn：点击取消处理函数
  const { step, stepAdd, cancelFn, prevStep, disabled, suposUrl } = props;

  // 立即使用
  const handleImmediateUse = () => {
    if (!suposUrl) return;
    window.isBeforeunloadTip = false;
    window.location.href = suposUrl;
  };

  // 管理supOS
  const handleSuposManage = () => {
    window.isBeforeunloadTip = false;
    dispatch(
      envManage.changeEnvStatus({
        hasOperatingEnv: true,
      }),
    );
    window.hashHistory.push('/instances');
  };

  // 返回运行环境管理页面
  const goEnvManage = () => {
    window.hashHistory.push('/envManage');
  };

  // 取消安装  本期不做先注释
  // const cancelInstall = () => {
  //   confirm({
  //     title: intl.formatMessage(messages.cancelInstallTitle),
  //     onOk: () => {
  //       cancelTask({ name: 'ALL' }).then(() => {
  //         handleSuposManage();
  //       });
  //     },
  //   });
  // };

  const btnData: any = {
    fileConfig: [
      {
        title: 'exitText',
        callback: cancelFn,
        position: 'left',
      },
      {
        title: 'nextStep',
        callback: stepAdd,
        position: 'right',
        type: 'primary',
      },
    ],
    deploy: [
      {
        title: 'exitText',
        callback: cancelFn,
        position: 'left',
      },
      {
        title: 'nextStep',
        callback: stepAdd,
        position: 'right',
        type: 'primary',
      },
      {
        title: 'prevStep',
        callback: prevStep,
        position: 'right',
        classname: 'prevStep',
      },
    ],
    nodeConfig: [
      {
        title: 'exitText',
        callback: cancelFn,
        position: 'left',
      },

      {
        title: 'nextStep',
        callback: stepAdd,
        position: 'right',
        type: 'primary',
      },
      {
        title: 'prevStep',
        callback: prevStep,
        position: 'right',
        classname: 'prevStep',
      },
    ],

    authorization: [
      {
        title: 'exitText',
        callback: cancelFn,
        position: 'left',
      },

      {
        title: 'nextStep',
        callback: stepAdd,
        position: 'right',
        type: 'primary',
      },
      {
        title: 'prevStep',
        callback: prevStep,
        position: 'right',
        classname: 'prevStep',
      },
    ],

    database: [
      {
        title: 'exitText',
        callback: cancelFn,
        position: 'left',
      },
      {
        title: 'startInstall',
        callback: stepAdd,
        position: 'right',
        type: 'primary',
      },
      {
        title: 'prevStep',
        callback: prevStep,
        position: 'right',
        classname: 'prevStep',
      },
    ],
    installList: cluster
      ? [
          {
            title: 'returnSystem',
            callback: handleSuposManage,
            position: 'left',
            disabled: disabled,
          },
          {
            title: 'immediateUse',
            callback: handleImmediateUse,
            position: 'right',
            disabled: disabled,
            type: 'primary',
          },
          // {
          //   title: 'cancelInstall',
          //   callback: cancelInstall,
          //   position: 'right',
          //   disabled: !disabled,
          //   classname: 'cancelInstall',
          // },
        ]
      : [
          {
            title: 'returnSystem',
            callback: handleSuposManage,
            position: 'left',
            disabled: disabled,
          },
          {
            title: 'immediateUse',
            callback: handleImmediateUse,
            position: 'right',
            disabled: disabled,
            type: 'primary',
          },
        ],
  };
  // 如果支持运多实例，添加返回运行环境按钮
  if (enableMultiInstance) {
    btnData.installList.unshift({
      title: 'envManage',
      callback: goEnvManage,
      position: 'left',
      classname: 'envManage',
    });
  }
  return (
    <div className={`${styles.footer} ${styles[step]}`}>
      <div className={styles.center}>
        {btnData[step]?.map((item: any) => (
          <div style={{ float: item.position }} key={item.title}>
            <Button
              onClick={item.callback}
              className={styles[item.classname]}
              disabled={item.disabled}
              type={item.type}
            >
              {intl.formatMessage(messages[item.title])}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Footer;
